module.exports = __webpack_public_path__ + "static/img/s2.2ccd8b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s2.png
// module id = zD+d
// module chunks = 0